import axios from 'axios';
import getHeaders from '../../constants/headers';
import { STORE_BASE_URL } from '../BaseURL';
export const getStoreRiderInfo = (storeId) => {
  return axios({
    method: 'get',
    url: STORE_BASE_URL + '/store/api/secure/v1/store/' + storeId + '/rider', // for android use
    headers: getHeaders(),
  });
};

export const getStoreTimeSlot = (storeId, currentTime) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/time-slot/' +
      currentTime, // for android use
    headers: getHeaders(),
  });
};

export const postPickupRequest = (id, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/pickup', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updatePickupRequest = (id, storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/pickup', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const postDeliveryRequest = (id, storeId, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/delivery', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const updateDeliveryRequest = (id, storeId, data) => {
  return axios({
    method: 'put',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/store-customer/' +
      id +
      '/delivery', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const getStoreRiderJobPickupOrDelivery = (storeId, jobType) => {
  return axios({
    method: 'get',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/rider-job/' +
      jobType, // for android use
    headers: getHeaders(),
  });
};

export const postStoreRiderJobPickupOrDelivery = (storeId, jobType, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v1/store/' +
      storeId +
      '/rider-' +
      jobType +
      '-job', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};

export const searchRiderOrderBulkOutForDelivery = (storeId, jobType, data) => {
  return axios({
    method: 'post',
    url:
      STORE_BASE_URL +
      '/store/api/secure/v4/store/' +
      storeId +
      '/rider-' +
      jobType +
      '-job', // for android use
    headers: getHeaders(),
    data: JSON.stringify(data),
  });
};